import { Card, SvgIcon } from '@mui/material';
import { RiArrowRightSLine } from '@remixicon/react';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { Link } from 'react-router';
import { renderSkeletonCards } from '../../../components/SkeletonElements';
import { useIotsApi } from '../../../contexts/iotsApi';
import { useLanguage } from '../../../contexts/language';
import useQueryErrorNotifier from '../../../hooks/useQueryErrorNotifier';

const MainPage = () => {
  const { t, language } = useLanguage();
  const { getPublicIslands } = useIotsApi();
  const {
    data: fetchedIslands = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: ['public-islands'],
    queryFn: () => getPublicIslands(),
  });

  useQueryErrorNotifier([error]);

  const islands = useMemo(
    () =>
      [...fetchedIslands].sort((a, b) =>
        a.names[language].localeCompare(b.names[language]),
      ),
    [fetchedIslands, language],
  );

  return (
    <>
      <section className="relative w-full">
        <img
          src="/images/public-page-hero-image.jpg"
          alt="Ferry sailing"
          className="w-full object-cover max-h-[400px]"
        />
        <div className="absolute inset-0 flex flex-col justify-center px-4 sm:px-8 md:px-16">
          <h1 className="text-white font-bold tracking-tight max-w-3xl text-2xl sm:text-4xl md:text-5xl leading-snug sm:leading-tight">
            {t('content.hero-image.title-line-1')}
            <span className="hidden sm:inline">
              <br />
            </span>
            <span className="inline sm:hidden">&nbsp;</span>
            {t('content.hero-image.title-line-2')}
          </h1>
          <p className="text-white mt-3 sm:mt-4 sm:text-lg max-w-xl">
            {t('content.hero-image.subtitle')}
          </p>
          <img
            title={t('content.drcdg-title')}
            className="absolute top-0 right-0 h-[60px] sm:h-[88px]"
            src="/images/drcdg_std_white.png"
          />
        </div>
      </section>
      <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 my-4 main-content">
        {!isLoading
          ? islands.map(island => (
              <Link to={`/islands/${island.id}`} key={island.id}>
                <li className="flex items-stretch">
                  <Card
                    variant="outlined"
                    className="w-full p-6 font-semibold flex justify-between items-center"
                  >
                    <header>{island.names[language]}</header>
                    <SvgIcon
                      className="h-[24px] w-[24px]"
                      component={RiArrowRightSLine}
                    />
                  </Card>
                </li>
              </Link>
            ))
          : renderSkeletonCards(10)}
      </ul>
    </>
  );
};

export default MainPage;
